import React, { useEffect, useState } from "react";
import Header from "../../../Components/comman/Header";
import SideMenu from "../SideMenu";
import {
  Button,
  Form,
  Modal,
  Nav,
  Row,
  Tab,
  Offcanvas,
  InputGroup,
} from "react-bootstrap";
import { FaPlus } from "react-icons/fa6";
import { BsThreeDotsVertical, BsInfoCircle } from "react-icons/bs";
import {
  PiArrowCounterClockwiseBold,
  PiCopy,
  PiEyeSlash,
  PiTrash,
} from "react-icons/pi";
import { FaEdit } from "react-icons/fa";
import Images from "../../../Helpers/Images";
import Select from "react-select";
import PlatformOptions from "../../../Helpers/PlatformOptions.json";
import StatusOptions from "../../../Helpers/Status.json";
import MobileHeader from "../../../Components/comman/MobileHeader";
import Aos from "aos";

const customStyles = {
  menu: (provided) => ({
    ...provided,
    backgroundColor: "#f4f4f8",
    fontWeight: "bold",
  }),
  option: (provided, state) => ({
    ...provided,
    fontWeight: "bold",
    backgroundColor: state.isSelected ? "#afd7d1" : "#f4f4f8",
    color: state.isSelected ? "#000000" : "#575757",
    borderBottom: "1px solid #ccc",
    "&:last-child": {
      borderBottom: "none",
    },
    "&:hover": {
      backgroundColor: "#afd7d1",
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    fontWeight: "bold",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#bdbdbd",
  }),
  input: (provided) => ({
    ...provided,
    fontWeight: "bold",
  }),
  control: (provided, state) => ({
    ...provided,
    borderColor: "#dee2e6",
    boxShadow: "none",
    "&:hover": {
      borderColor: "#dee2e6",
    },
  }),
};

const AnalyticsHome = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [widgetShow, setWidgetShow] = useState(false);
  const widgetClose = () => setWidgetShow(false);
  const handleWidgetShow = () => setWidgetShow(true);

  useEffect(() => {
    Aos.init({});
  }, []);
  return (
    <div className="brand-dashboard-wrapper">
      <Header />
      <MobileHeader />
      <div className="brand-dashboard-inner ">
        <Tab.Container activeKey={`analytics`}>
          <SideMenu />
          <div className="brand-dashboard-content-wrapper">
            <Tab.Content>
              <Tab.Pane eventKey={"analytics"}>
                <div className="analytics-wrapper">
                  <h6 className="heading-title">Analytics</h6>
                  <Tab.Container defaultActiveKey="default-view">
                    <Row className="analytics-wrap">
                      <Nav variant="tabs" className="flex-row">
                        <Nav.Item className="tab-list-item">
                          <Nav.Link eventKey="default-view">
                            Default View
                          </Nav.Link>
                        </Nav.Item>
                        <Button className="add-new-btn" onClick={handleShow}>
                          <FaPlus />
                          New View
                        </Button>
                      </Nav>
                      <Tab.Content>
                        <Tab.Pane eventKey="default-view">
                          <div className="content-area">
                            <div
                              className="boxes-wrapper"
                              data-aos="fade-up"
                              data-aos-duration="1500"
                            >
                              <div className="total-campaigns common-box">
                                <div className="heading">
                                  <h5>Total Campaigns</h5>
                                  <BsThreeDotsVertical
                                    onClick={handleWidgetShow}
                                  />
                                </div>
                                <div className="content">
                                  <p className="amount">2</p>
                                </div>
                              </div>
                              <div className="total-payouts common-box">
                                <div className="heading">
                                  <h5>Total Payouts</h5>
                                  <BsThreeDotsVertical
                                    onClick={handleWidgetShow}
                                  />
                                </div>
                                <div className="content">
                                  <p className="amount">
                                    $0.0 <span>USD</span>
                                  </p>
                                </div>
                              </div>
                              <div className="creator-stats common-box ">
                                <div className="heading">
                                  <h5>Creator Stats</h5>
                                  <BsThreeDotsVertical
                                    onClick={handleWidgetShow}
                                  />
                                </div>
                                <div className="content">
                                  <p className="amount">
                                    0 <span>(total followers)</span>
                                  </p>
                                  <p className="amount">
                                    0 % <span>(avg. engagement)</span>
                                  </p>
                                </div>
                              </div>
                              <div className="audience-ages common-box">
                                <div className="heading">
                                  <h5>Audience Ages</h5>
                                  <BsThreeDotsVertical
                                    onClick={handleWidgetShow}
                                  />
                                </div>
                                <div className="content">
                                  <img src={Images.noData} alt="no data" />
                                  <p>No Data</p>
                                </div>
                              </div>
                            </div>
                            <div
                              className="boxes-wrapper"
                              data-aos="fade-up"
                              data-aos-duration="1500"
                            >
                              <div className="audience-ages common-box">
                                <div className="heading">
                                  <h5>Audience Brand Affinity</h5>
                                  <BsThreeDotsVertical
                                    onClick={handleWidgetShow}
                                  />
                                </div>
                                <div className="content">
                                  <img src={Images.noData} alt="no data" />
                                  <p>No Data</p>
                                </div>
                              </div>
                              <div className="audience-ages common-box">
                                <div className="heading">
                                  <h5>Audience Ethnicity</h5>
                                  <BsThreeDotsVertical
                                    onClick={handleWidgetShow}
                                  />
                                </div>
                                <div className="content">
                                  <img src={Images.noData} alt="no data" />
                                  <p>No Data</p>
                                </div>
                              </div>
                              <div className="audience-ages common-box">
                                <div className="heading">
                                  <h5>Audience Gender</h5>
                                  <BsThreeDotsVertical
                                    onClick={handleWidgetShow}
                                  />
                                </div>
                                <div className="content">
                                  <img src={Images.noData} alt="no data" />
                                  <p>No Data</p>
                                </div>
                              </div>
                            </div>
                            <div
                              className="boxes-wrapper"
                              data-aos="fade-up"
                              data-aos-duration="1500"
                            >
                              <div className="audience-ages common-box">
                                <div className="heading">
                                  <h5>Audience Interests</h5>
                                  <BsThreeDotsVertical
                                    onClick={handleWidgetShow}
                                  />
                                </div>
                                <div className="content">
                                  <img src={Images.noData} alt="no data" />
                                  <p>No Data</p>
                                </div>
                              </div>
                              <div className="audience-ages common-box">
                                <div className="heading">
                                  <h5>Audience Languages</h5>
                                  <BsThreeDotsVertical
                                    onClick={handleWidgetShow}
                                  />
                                </div>
                                <div className="content">
                                  <img src={Images.noData} alt="no data" />
                                  <p>No Data</p>
                                </div>
                              </div>
                              <div className="audience-ages common-box">
                                <div className="heading">
                                  <h5>Audience Reachability</h5>
                                  <BsThreeDotsVertical
                                    onClick={handleWidgetShow}
                                  />
                                </div>
                                <div className="content">
                                  <img src={Images.noData} alt="no data" />
                                  <p>No Data</p>
                                </div>
                              </div>
                            </div>
                            <div
                              className="boxes-wrapper"
                              data-aos="fade-up"
                              data-aos-duration="1500"
                            >
                              <div className="audience-ages common-box">
                                <div className="heading">
                                  <h5>Audience Location</h5>
                                  <BsThreeDotsVertical
                                    onClick={handleWidgetShow}
                                  />
                                </div>
                                <div className="content">
                                  <img src={Images.noData} alt="no data" />
                                  <p>No Data</p>
                                </div>
                              </div>
                              <div className="audience-ages common-box">
                                <div className="heading">
                                  <h5>Total ROI</h5>
                                  <BsThreeDotsVertical
                                    onClick={handleWidgetShow}
                                  />
                                </div>
                                <div className="content">
                                  <img src={Images.noData} alt="no data" />
                                  <p>No Data</p>
                                </div>
                              </div>
                              <div className="audience-ages common-box">
                                <div className="heading">
                                  <h5>Campaign Performance Snapshot</h5>
                                  <BsThreeDotsVertical
                                    onClick={handleWidgetShow}
                                  />
                                </div>
                                <div className="content">
                                  <img src={Images.noData} alt="no data" />
                                  <p>No Data</p>
                                </div>
                              </div>
                            </div>
                            <div
                              className="boxes-wrapper"
                              data-aos="fade-up"
                              data-aos-duration="1500"
                            >
                              <div className="engagement-snapshot common-box">
                                <div className="heading">
                                  <h5>Content Engagement Snapshot</h5>
                                  <BsThreeDotsVertical
                                    onClick={handleWidgetShow}
                                  />
                                </div>
                                <div className="innerboxes-wrapper">
                                  <div className="inner-boxes">
                                    <div className="heading">
                                      <p>Comments</p> <BsInfoCircle />
                                    </div>
                                    <div className="content">
                                      <p>0</p>
                                    </div>
                                  </div>
                                  <div className="inner-boxes">
                                    <div className="heading">
                                      <p>Likes</p> <BsInfoCircle />
                                    </div>
                                    <div className="content">
                                      <p>0</p>
                                    </div>
                                  </div>
                                  <div className="inner-boxes">
                                    <div className="heading">
                                      <p>Views</p> <BsInfoCircle />
                                    </div>
                                    <div className="content">
                                      <p>0</p>
                                    </div>
                                  </div>
                                  <div className="inner-boxes">
                                    <div className="heading">
                                      <p>Reach</p> <BsInfoCircle />
                                    </div>
                                    <div className="content">
                                      <p>0</p>
                                    </div>
                                  </div>
                                  <div className="inner-boxes">
                                    <div className="heading">
                                      <p>Impressions</p> <BsInfoCircle />
                                    </div>
                                    <div className="content">
                                      <p>0</p>
                                    </div>
                                  </div>
                                  <div className="inner-boxes">
                                    <div className="heading">
                                      <p>Saves</p> <BsInfoCircle />
                                    </div>
                                    <div className="content">
                                      <p>0</p>
                                    </div>
                                  </div>
                                  <div className="inner-boxes">
                                    <div className="heading">
                                      <p>Shares</p> <BsInfoCircle />
                                    </div>
                                    <div className="content">
                                      <p>0</p>
                                    </div>
                                  </div>
                                  <div className="inner-boxes">
                                    <div className="heading">
                                      <p>Avg. Engagement</p> <BsInfoCircle />
                                    </div>
                                    <div className="content">
                                      <p>0 %</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="total-content common-box">
                                <div className="heading">
                                  <h5>Total Content</h5>
                                  <BsThreeDotsVertical
                                    onClick={handleWidgetShow}
                                  />
                                </div>
                                <div className="content">
                                  <img src={Images.noData} alt="no data" />
                                  <p>No Data</p>
                                </div>
                              </div>
                            </div>
                            <div
                              className="boxes-wrapper"
                              data-aos="fade-up"
                              data-aos-duration="1500"
                            >
                              <div className="audience-ages common-box">
                                <div className="heading">
                                  <h5>Affiliate Sales vs Posts</h5>
                                  <BsThreeDotsVertical
                                    onClick={handleWidgetShow}
                                  />
                                </div>
                                <div className="content">
                                  <img src={Images.noData} alt="no data" />
                                  <p>No Data</p>
                                </div>
                              </div>
                              <div className="audience-ages common-box">
                                <div className="heading">
                                  <h5>Influencer Brand Affinity</h5>
                                  <BsThreeDotsVertical
                                    onClick={handleWidgetShow}
                                  />
                                </div>
                                <div className="content">
                                  <img src={Images.noData} alt="no data" />
                                  <p>No Data</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Tab.Pane>
                      </Tab.Content>
                    </Row>
                  </Tab.Container>

                  {/* modal */}
                  <Modal
                    className="analytics-modal"
                    show={show}
                    onHide={handleClose}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>New View</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form>
                        <Form.Label>Enter Title</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="e.g. My Campaign Performance"
                          autoFocus
                        />
                      </Form>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button onClick={handleClose}>Create New</Button>
                    </Modal.Footer>
                  </Modal>

                  {/* side widget */}
                  <Offcanvas
                    className="analytics-widget"
                    show={widgetShow}
                    onHide={widgetClose}
                    placement="end"
                  >
                    <Offcanvas.Header closeButton>
                      <Offcanvas.Title>Edit Widget</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                      <Form>
                        <Form.Group controlId="formInput" className="mb-3">
                          <Form.Label>Title</Form.Label>
                          <InputGroup>
                            <InputGroup.Text>
                              <FaEdit />
                            </InputGroup.Text>
                            <Form.Control
                              type="text"
                              defaultValue="Total Campaigns"
                            />
                          </InputGroup>
                        </Form.Group>

                        <Form.Group controlId="formSelect1" className="mb-3">
                          <Form.Label>Campaign Status</Form.Label>
                          <Select
                            options={StatusOptions}
                            placeholder={"Select"}
                            styles={customStyles}
                          />
                        </Form.Group>

                        <Form.Group controlId="formSelect2" className="mb-3">
                          <Form.Label>Campaign Status</Form.Label>
                          <Select
                            options={PlatformOptions}
                            placeholder={"Select"}
                            styles={customStyles}
                          />
                        </Form.Group>
                        <div className="btn-sec">
                          <Button className="theme-btn" type="submit">
                            Save
                          </Button>
                          <Button type="submit" className="outlined-btn">
                            Reset
                          </Button>
                        </div>
                      </Form>
                      <div className="action-btns">
                        <a>
                          <PiArrowCounterClockwiseBold />
                          Default
                        </a>
                        <a>
                          <PiCopy />
                          Duplicate
                        </a>
                        <a>
                          {" "}
                          <PiEyeSlash />
                          Hide
                        </a>
                        <a className="delete">
                          <PiTrash /> Delete
                        </a>
                      </div>
                    </Offcanvas.Body>
                  </Offcanvas>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </div>
    </div>
  );
};

export default AnalyticsHome;
